/* LYS — PANIER v2 plein écran (maquettes 18/07). Jost, monochrome, ouverture instantanée.
   - Ouvre IMMÉDIATEMENT (rendu depuis le cache /cart.js préchargé), réseau en arrière-plan.
   - PC 2 colonnes (articles+totaux+écrin | paliers+bundle) / mobile empilé — ordre des maquettes.
   - Qté en menu déroulant, ligne Livraison→Informations (accordéon lys-ship-info), zéro emoji.
   - Ligne Swiss HD (supplément caché) foldée + synchro qty. Bundle 3+1 / 2+1 : économie projetée
     (remises automatiques Shopify actives au checkout). */
(function(){
  var root = document.getElementById('lysCartDrawer');
  if(!root) return;
  var CFG; try{ CFG = JSON.parse(document.getElementById('lysCartCfg').textContent); }catch(e){ CFG = {t:{},thresholds:{},zeroDec:[],wigs:[],exts:[]}; }
  var T = CFG.t || {};
  var SWISS_HANDLE = 'swiss-hd-lace-supplement';
  var SWISS_UNIT = parseInt(root.dataset.swiss||'0',10)||0;
  var SWISS_VAR = parseInt(root.dataset.swissVar||'0',10)||0;
  /* supplément TEXTURE extensions (pattern Swiss, 20/07) : { "Ondulé": {v:variantId,u:centimes}, ... } */
  var TEX_HANDLE = 'texture-supplement-lys';
  var TEX = {}; try{ TEX = JSON.parse(root.dataset.tex||'{}'); }catch(e){ TEX = {}; }
  function texVarIds(){ var ids=[]; for(var k in TEX) ids.push(TEX[k].v); return ids; }
  function isSuppLine(it){ return it.handle===SWISS_HANDLE || it.handle===TEX_HANDLE; }
  function texOf(it){ var t = it.properties && it.properties['Texture']; return (t && TEX[t]) ? TEX[t] : null; }
  var PKG = root.dataset.pkg||'';
  var bodyEl = document.getElementById('lyscdBody');
  var CART = null, busy = false, shipOpen = false;

  /* ---------- utils ---------- */
  function cur(){ return (CART&&CART.currency) || CFG.shopCurrency || 'EUR'; }
  function dec(){ return (CFG.zeroDec||[]).indexOf(cur())>=0 ? 0 : 2; }
  function money(cents){
    // Shopify renvoie TOUTES les devises en centièmes (JPY inclus : ¥33 000 → 3300000).
    // zeroDec ne joue que sur les décimales AFFICHÉES, jamais sur l'unité.
    var d=dec(), v=cents/100;
    try{ return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency:cur(),minimumFractionDigits:d,maximumFractionDigits:d}).format(v); }
    catch(e){ return v.toFixed(d)+' '+cur(); }
  }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function thumb(u,w){ if(!u) return ''; return u + (u.indexOf('?')>=0?'&':'?') + 'width='+(w||200); }
  function isWig(it){ var p=(it.product_type||'').toLowerCase(); return p.indexOf('perruque')>=0||p.indexOf('wig')>=0; }
  function isExt(it){ var p=(it.product_type||'').toLowerCase(); return p.indexOf('extension')>=0; }
  function thr(){ var c=cur(); var t=CFG.thresholds[c]||CFG.thresholds[CFG.shopCurrency]||[300,600]; return [t[0]*100,t[1]*100]; } // seuils -> centièmes (JPY inclus)

  /* ---------- cart fetch ---------- */
  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function refresh(){ return getCart().then(function(c){ CART=c; if(root.classList.contains('open')) render(); updateBubble(); }); }

  function updateBubble(){
    if(!CART) return;
    var supp=0; CART.items.forEach(function(it){ if(isSuppLine(it)) supp+=it.quantity; });
    var vis=CART.item_count-supp;
    var b=document.getElementById('rinaCartCount');
    if(b){ b.textContent=vis; b.classList.toggle('hidden', vis<=0); }
  }

  /* ---------- Swiss HD sync ---------- */
  function swissLine(){ for(var i=0;i<CART.items.length;i++){ if(CART.items[i].handle===SWISS_HANDLE) return CART.items[i]; } return null; }
  function swissNeeded(){ var n=0; CART.items.forEach(function(it){ if(it.handle!==SWISS_HANDLE && it.properties && it.properties['Swiss HD Lace']==='Oui') n+=it.quantity; }); return n; }
  function change(body){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json();}); }
  function syncSwiss(){
    var need=swissNeeded(), line=swissLine(), have=line?line.quantity:0;
    if(need===have) return Promise.resolve();
    if(line) return change({id:line.key,quantity:need});
    if(need>0 && SWISS_VAR) return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:SWISS_VAR,quantity:need})});
    return Promise.resolve();
  }
  /* ---------- Texture sync (une ligne supplément PAR texture, qty = somme des lignes marquées) ---------- */
  function syncTex(){
    var chain = Promise.resolve();
    Object.keys(TEX).forEach(function(label){
      var vId = TEX[label].v;
      var need = 0, line = null;
      CART.items.forEach(function(it){
        if(it.handle===TEX_HANDLE){ if(it.variant_id===vId) line=it; return; }
        if(it.properties && it.properties['Texture']===label) need+=it.quantity;
      });
      var have = line ? line.quantity : 0;
      if(need===have) return;
      chain = chain.then(function(){
        if(line) return change({id:line.key,quantity:need}).then(function(c){ CART=c; });
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:vId,quantity:need})});
      });
    });
    return chain;
  }

  /* ---------- item ops ---------- */
  function setBusy(b){ busy=b; root.classList.toggle('lyscd--busy', b); }
  function setQty(key,qty){
    if(busy) return; setBusy(true);
    change({id:key,quantity:Math.max(0,qty)})
      .then(function(c){ CART=c; return syncSwiss(); })
      .then(getCart).then(function(c){ CART=c; return syncTex(); })
      .then(getCart).then(function(c){ CART=c; render(); updateBubble(); })
      .catch(function(){}).then(function(){ setBusy(false); });
  }
  function quickAdd(vid){
    if(busy||!vid) return; setBusy(true);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
      .then(getCart).then(function(c){ CART=c; render(); updateBubble(); })
      .catch(function(){}).then(function(){ setBusy(false); });
  }

  /* ---------- bundle math (projeté) ---------- */
  function bundle(){
    var wUnits=[], eUnits=[];
    CART.items.forEach(function(it){
      if(isSuppLine(it)) return;
      var q=it.quantity, u=it.price;
      var arr=isWig(it)?wUnits:(isExt(it)?eUnits:null);
      if(arr) for(var i=0;i<q;i++) arr.push(u);
    });
    function calc(units,buy){
      units.sort(function(a,b){return a-b;});
      var group=buy+1, free=Math.floor(units.length/group), save=0;
      for(var i=0;i<free;i++) save+=units[i];
      return {count:units.length, free:free, save:save};
    }
    var W=calc(wUnits,3), E=calc(eUnits,2);
    W.need = W.count===0?3:(W.count%4===0?0:4-(W.count%4));
    E.need = E.count===0?2:(E.count%3===0?0:3-(E.count%3));
    return {W:W,E:E,save:W.save+E.save};
  }

  /* ---------- ship info (accordéon) ---------- */
  function shipHtml(){
    var tpl=document.getElementById('lyscdShipTpl');
    if(!tpl) return '';
    var d=document.createElement('div'); d.innerHTML=tpl.innerHTML;
    d.querySelectorAll('script,style').forEach(function(s){ s.remove(); }); // style/script déjà dans le DOM via l'original
    return d.innerHTML;
  }

  /* ---------- render ---------- */
  function render(){
    if(!CART){ bodyEl.innerHTML=''; return; }
    var supp=0; CART.items.forEach(function(it){ if(isSuppLine(it)) supp+=it.quantity; });
    var vis=CART.item_count-supp;
    if(vis<=0){
      bodyEl.innerHTML='<div class="lyscd-empty lyscd-anim"><p class="lyscd-empty__t">'+esc(T.empty_title)+'</p><p class="lyscd-empty__x">'+esc(T.empty_text)+'</p><a class="lyscd__co lyscd__co--sm" href="/collections/toutes-les-perruques">'+esc(T.empty_cta)+'</a></div>';
      return;
    }
    var th=thr(), total=CART.total_price, bd=bundle();
    /* — paliers (droite PC / haut mobile) — */
    var perks='<div class="lyscd-bl lyscd-bl--perks lyscd-anim"><div class="lyscd-perk">';
    if(total>=th[0]) perks+='<div class="lyscd-perk__row is-ok">'+ico('truck')+'<span>'+esc(T.ship_ok)+'</span></div>';
    else perks+='<div class="lyscd-perk__row">'+ico('truck')+'<span>'+esc(T.ship_need).replace('%amt%',money(th[0]-total))+'</span></div>';
    perks+='<div class="lyscd-bar"><i style="width:'+Math.min(100,total/th[0]*100).toFixed(1)+'%"></i></div>';
    var reward=money(Math.round(th[1]/6));
    if(total>=th[1]) perks+='<div class="lyscd-perk__row is-ok">'+ico('gift')+'<span>'+esc(T.reward_ok).replace('%reward%',reward)+'</span></div>';
    else perks+='<div class="lyscd-perk__row">'+ico('gift')+'<span>'+esc(T.reward_need).replace('%amt%',money(th[1]-total)).replace('%reward%',reward)+'</span></div>';
    perks+='<div class="lyscd-perk__sep"></div></div></div>';
    /* — articles (gauche) — */
    var items='<div class="lyscd-bl lyscd-bl--items lyscd-anim"><div class="lyscd-items">';
    CART.items.forEach(function(it){
      if(isSuppLine(it)) return;
      var swiss = it.properties && it.properties['Swiss HD Lace']==='Oui';
      var tex = texOf(it);
      var line = it.final_line_price + (swiss?SWISS_UNIT*it.quantity:0) + (tex?tex.u*it.quantity:0);
      var vt = it.variant_title && it.variant_title!=='Default Title' ? esc(it.variant_title) : '';
      if(swiss) vt = (vt?vt+' · ':'')+esc(T.swiss);
      if(tex) vt = (vt?vt+' · ':'')+esc(it.properties['Texture']);
      var mx=Math.max(10,it.quantity), opts='';
      for(var q=1;q<=mx;q++) opts+='<option value="'+q+'"'+(q===it.quantity?' selected':'')+'>'+q+'</option>';
      items+='<div class="lyscd-it" data-key="'+esc(it.key)+'">'
        + '<a class="lyscd-it__img" href="'+esc(it.url)+'"><img src="'+esc(thumb(it.image,200))+'" alt="'+esc(it.product_title)+'" loading="lazy"></a>'
        + '<div class="lyscd-it__main">'
          + '<a class="lyscd-it__t" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'
          + (vt?'<div class="lyscd-it__v">'+vt+'</div>':'')
          + '<div class="lyscd-it__row">'
            + '<label class="lyscd-qsel"><span>'+esc(T.qty)+'</span><select data-act="qsel">'+opts+'</select>'+ico('chev')+'</label>'
            + '<span class="lyscd-it__p">'+money(line)+'</span>'
          + '</div>'
          + '<div class="lyscd-it__links"><a class="lyscd-it__lk" href="'+esc(it.url)+'">'+esc(T.modify)+'</a><button class="lyscd-it__lk" data-act="rm" type="button">'+esc(T.remove)+'</button></div>'
        + '</div></div>';
    });
    items+='</div></div>';
    /* — totaux (gauche) — */
    var save=bd.save;
    var sum='<div class="lyscd-bl lyscd-bl--sum lyscd-anim"><div class="lyscd-sum">'
      + '<div class="lyscd-sum__r"><span class="lyscd-sum__mut">'+esc(T.subtotal)+'</span><span>'+money(total)+'</span></div>'
      + (save>0?'<div class="lyscd-sum__r lyscd-sum__save"><span class="lyscd-sum__mut">'+esc(T.bundle_offered)+'</span><span>&minus;'+money(save)+'</span></div>':'')
      + '<div class="lyscd-sum__r"><div class="lyscd-sum__ship"><span>'+esc(T.shipping)+'</span>'
        + '<button class="lyscd-sum__shipinfo'+(shipOpen?' is-open':'')+'" data-act="shipinfo" type="button">'+esc(T.ship_info)+' '+ico('arr')+'</button></div>'
        + '<span class="lyscd-sum__mut">--</span></div>'
      + '<div class="lyscd-sum__r lyscd-sum__tot"><span>'+esc(T.total)+'</span><span>'+money(Math.max(0,total-save))+'</span></div>'
      + '</div><div class="lyscd-shipx'+(shipOpen?' is-open':'')+'" id="lyscdShipx">'+shipHtml()+'</div></div>';
    /* — bundle (droite) — */
    var b='<div class="lyscd-bl lyscd-bl--bundle lyscd-anim"><section class="lyscd-b"><div class="lyscd-b__h">'+esc(T.bundle_title)+'</div>';
    b+=bundleTrack(T.bundle_wigs, bd.W, T.bundle_need_wig, 4);
    b+=bundleTrack(T.bundle_ext, bd.E, T.bundle_need_ext, 3);
    var qa=(CFG.wigs||[]).concat(CFG.exts||[]).slice(0,4);
    if(qa.length){
      b+='<div class="lyscd-b__add"><span class="lyscd-b__addh">'+esc(T.bundle_add)+'</span><div class="lyscd-qa">';
      qa.forEach(function(p){
        b+='<div class="lyscd-qa__c"><a href="/products/'+esc(p.h)+'"><img src="'+esc(p.img)+'" alt="'+esc(p.t)+'" loading="lazy"></a>'
          +'<span class="lyscd-qa__p">'+money(p.p)+'</span>'
          +'<button class="lyscd-qa__b" data-add="'+esc(p.v)+'" type="button">'+esc(T.bundle_add)+'</button></div>';
      });
      b+='</div></div>';
    }
    b+='</section></div>';
    /* — écrin offert (gauche) — */
    var pkg='<div class="lyscd-bl lyscd-bl--pkg lyscd-anim"><div class="lyscd-pkg"><div class="lyscd-pkg__txt"><span class="lyscd-pkg__badge">'+esc(T.pkg_label)+'</span><span class="lyscd-pkg__t">'+esc(T.pkg_title)+'</span><span class="lyscd-pkg__x">'+esc(T.pkg_text)+'</span></div>'
      + (PKG?'<img class="lyscd-pkg__img" src="'+esc(PKG)+'" alt="'+esc(T.pkg_title)+'" loading="lazy">':'')+'</div></div>';
    /* — paiement + CTA — */
    var co='<div class="lyscd-checkout"><span class="lyscd-pay__h">'+esc(T.pay_title)+'</span><div class="lyscd-pay__ic">'+payIcons()+'</div>'
      + '<div class="lyscd-secure">'+ico('lock')+'<div><b>'+esc(T.secure_title)+'</b><span>'+esc(T.secure_text)+'</span></div></div>'
      + '<a class="lyscd__co" href="/checkout" id="lyscdCheckout">'+esc(T.checkout)+'</a>'
      + '<button class="lyscd__cont" data-close type="button">'+esc(T.continue)+'</button></div>';
    bodyEl.innerHTML='<div class="lyscd-grid"><div class="lyscd-colL">'+items+sum+pkg+'</div><div class="lyscd-colR">'+perks+b+'</div></div>'+co;
    if(shipOpen && window.__lysShipJs) window.__lysShipJs();
  }

  function bundleTrack(label, d, needTpl, group){
    var pct = d.free>0?100:(d.count%group)/group*100;
    var msg = d.free>0
      ? '<span class="lyscd-bt__ok">'+ico('gift')+' '+esc(T.bundle_free)+' &times;'+d.free+'</span>'
      : '<span>'+esc(needTpl).replace('%n%',d.need)+'</span>';
    return '<div class="lyscd-bt"><div class="lyscd-bt__lbl">'+esc(label)+'</div><div class="lyscd-bar"><i style="width:'+pct.toFixed(0)+'%"></i></div><div class="lyscd-bt__msg">'+msg+'</div></div>';
  }

  /* ---------- icônes (SVG uniquement — aucun emoji) ---------- */
  function ico(n){
    if(n==='truck') return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M1 4h13v11H1zM14 8h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="18" cy="18" r="1.8"/></svg>';
    if(n==='gift') return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M2 9h20v4H2zM4 13v8h16v-8M12 9v12M12 9S9 3 6.5 5 12 9 12 9zM12 9s3-6 5.5-4S12 9 12 9z"/></svg>';
    if(n==='lock') return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3"><rect x="4" y="10" width="16" height="11" rx="1.5"/><path d="M8 10V7a4 4 0 018 0v3"/></svg>';
    if(n==='chev') return '<svg viewBox="0 0 12 12" width="9" height="9" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M2.5 4.5L6 8l3.5-3.5"/></svg>';
    if(n==='arr') return '<svg viewBox="0 0 12 12" width="8" height="8" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M4.5 2.5L8 6l-3.5 3.5"/></svg>';
    return '';
  }
  function payIcons(){
    var vs='<span class="lyscd-pi" title="Visa"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><text x="20" y="16" text-anchor="middle" font-family="Arial" font-weight="700" font-size="10" fill="#fff">VISA</text></svg></span>';
    var mc='<span class="lyscd-pi" title="Mastercard"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><circle cx="16" cy="12" r="6.5" fill="#fff" opacity=".9"/><circle cx="24" cy="12" r="6.5" fill="#fff" opacity=".55"/></svg></span>';
    var ax='<span class="lyscd-pi" title="American Express"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><text x="20" y="15" text-anchor="middle" font-family="Arial" font-weight="700" font-size="7" fill="#fff">AMEX</text></svg></span>';
    var pp='<span class="lyscd-pi" title="PayPal"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><text x="20" y="16" text-anchor="middle" font-family="Arial" font-style="italic" font-weight="700" font-size="9" fill="#fff">PayPal</text></svg></span>';
    var ap='<span class="lyscd-pi" title="Apple Pay"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><g fill="#fff"><path d="M12.6 8.2c.4-.5.7-1.2.6-1.9-.6 0-1.3.4-1.7.9-.4.4-.7 1.1-.6 1.8.7.1 1.3-.3 1.7-.8zm.6.9c-1 0-1.8.6-2.3.6-.5 0-1.2-.6-2-.6-1 0-2 .6-2.5 1.5-1.1 1.9-.3 4.7.7 6.2.5.8 1.1 1.6 1.9 1.6.8 0 1-.5 2-.5s1.2.5 2 .5 1.3-.8 1.8-1.5c.6-.9.8-1.7.8-1.8 0 0-1.6-.6-1.6-2.4 0-1.5 1.2-2.2 1.3-2.3-.7-1-1.8-1.2-2.1-1.3z"/><text x="24" y="16" text-anchor="middle" font-family="Arial" font-weight="600" font-size="9">Pay</text></g></svg></span>';
    return vs+mc+ax+pp+ap;
  }

  /* ---------- open / close (instantané, façon nav) ---------- */
  var armTimer=null;
  function open(){
    if(root.classList.contains('open')) return;
    root.classList.add('lyscd--armed');
    root.classList.add('open'); root.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('lyscd-lock');
    if(CART) render();
    clearTimeout(armTimer); armTimer=setTimeout(function(){ root.classList.remove('lyscd--armed'); },950);
    refresh();
  }
  function close(){ root.classList.remove('open'); root.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('lyscd-lock'); }
  window.lysOpenCart=function(e){ if(e){ e.preventDefault(); } open(); return false; };
  window.lysCloseCart=close;

  /* ---------- events ---------- */
  root.addEventListener('click',function(e){
    var c=e.target.closest('[data-close]'); if(c){ close(); return; }
    var add=e.target.closest('[data-add]'); if(add){ quickAdd(parseInt(add.getAttribute('data-add'),10)); return; }
    var si=e.target.closest('[data-act="shipinfo"]');
    if(si){
      shipOpen=!shipOpen;
      si.classList.toggle('is-open', shipOpen);
      var x=document.getElementById('lyscdShipx');
      if(x){ x.classList.toggle('is-open', shipOpen); if(shipOpen && window.__lysShipJs) window.__lysShipJs(); }
      return;
    }
    var it=e.target.closest('.lyscd-it'); if(!it) return;
    var key=it.getAttribute('data-key');
    if(e.target.closest('[data-act="rm"]')) setQty(key,0);
  });
  root.addEventListener('change',function(e){
    var s=e.target.closest('select[data-act="qsel"]'); if(!s) return;
    var it=e.target.closest('.lyscd-it'); if(!it) return;
    setQty(it.getAttribute('data-key'), parseInt(s.value,10)||1);
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&root.classList.contains('open')) close(); });

  // intercepte tout lien vers /cart (icône header, pin-nav, etc.)
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href]'); if(!a) return;
    if(a.hasAttribute('data-no-drawer')) return;
    var href=a.getAttribute('href')||'';
    if(/\/cart\/?($|\?)/.test(href) && !/\/cart\/(add|change|update|clear)/.test(href)){ e.preventDefault(); open(); }
  });

  // wrap fetch : rafraîchit la bulle après add/change/update.
  // 28/07 (retour cliente) : on n'OUVRE plus le panier plein écran après un ajout. L'ouverture
  // était déjà inhibée quand la requête contenait un supplément (Swiss HD / texture), donc :
  // perruque avec Swiss = on restait sur la fiche, extension lisse = plein écran. Incohérent.
  // Uniformisé sur le comportement validé par la cliente : on reste sur la fiche (✓ + bulle).
  var _f=window.fetch;
  window.fetch=function(){
    var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    var init = arguments[1] || (arguments[0] && arguments[0].body!=null ? arguments[0] : null);
    var body = init && init.body!=null ? String(init.body) : '';
    var isSwissAdd = SWISS_VAR && body.indexOf(String(SWISS_VAR))>=0; // sync supplément : ne pas ouvrir
    if(!isSwissAdd){ var tids=texVarIds(); for(var ti=0;ti<tids.length;ti++){ if(body.indexOf(String(tids[ti]))>=0){ isSwissAdd=true; break; } } }
    var p=_f.apply(this,arguments);
    if(typeof url==='string'){
      if(/\/cart\/add(\.js)?/.test(url) && !isSwissAdd) p.then(function(r){ if(r&&r.ok){ setTimeout(function(){ getCart().then(function(c){ CART=c; updateBubble(); }); },40); } });
      else if(/\/cart\/(change|update|clear)(\.js)?/.test(url)) p.then(function(r){ if(r&&r.ok){ setTimeout(function(){ getCart().then(function(c){ CART=c; updateBubble(); if(root.classList.contains('open')) render(); }); },40); } });
    }
    return p;
  };

  // préchargement : cache prêt AVANT le premier clic → ouverture instantanée
  getCart().then(function(c){ CART=c; updateBubble(); });
  window.addEventListener('pageshow',function(e){ if(e.persisted) refresh(); });
})();
